import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
    theme: {
        dark: false,
        themes: {
            light: {
                primary: '#4267b2',
            }
        }
    },
    icons: {
        iconfont: 'fa',
    },
});
